export const tracking = {
    EVENT: {
        CADASTRO_FUNNEL_STEPS: 'Cadastro_funnel_steps',
        CADASTRO_FUNEL_STEPS: 'Cadastro_funel_steps',
        VPAGEVIEW: 'vpageview',
        RESET_PASSWORD_FUNNEL_STEPS: 'reset_password_funel_steps',
        ACTIVATE_ACCOUNT_FUNNEL_STEPS: 'Ativacao_Cadastro_Steps',
        ACTIVATE_ACCOUNT_SUCCESS: 'Conta_Ativação_Concluída',
        ACTIVATE_CADASTRO_CONCLUIDO: 'Ativacao_Cadastro_Concluido',
        NEGATIVA_LOGIN: 'Negativa_Login',
        NEGATIVE_RESET: 'Negativa_Reset',
        FUNNEL_STEP: 'funnel_step',
    },
    STEPS: {
        MDM_DADOS_INCORRETOS: 'MDM_Dados_Incorretos',
        MDM_ATIVE_CADASTRO: 'MDM_Ative_Cadastro',
        MDM_VALIDACAO_TOKENS: 'MDM_Validação_Tokens',
        MDM_CADASTRO_CONCLUIDO: 'MDM_Cadastro_Concluido',
        MDM_CADASTRO: 'MDM_Cadastro',
        MDM_BOAS_VINDAS: 'MDM_Boas_Vindas',
        MDM_CRIE_SENHA: 'MDM_Crie_senha',
        MDM_PASSWORD: 'Mdm_Senha',
        MDM_CONTACT: 'Mdm_Contato',
        MDM_TOKEN: 'Mdm_Token',
        MDM_CADASTRO_SEXO: 'MDM_Sexo',
        NEW_SENHA: 'New_Senha',
        NEW_VALIDACAO_TOKENS: 'New_Validação_Tokens',
        NEW_CADASTRO_CONCLUIDO: 'New_Cadastro_concluido',
        NEW_CADASTRO_DADOS_PESSOAIS: 'Dados_Cadastrais',
        NEW_CADASTRO_SEXO: 'New_Sexo',
        NEW_CADASTRO_CEP: 'Cep',
        NEW_CADASTRO_EMAIL: 'New_Email',
        NEW_CADASTRO_TELEFONE: 'New_Telefone',
        NEW_CADASTRO: 'New_Cadastro',
        RESET_PASSWORD_CPF: 'Confirmar dados - CPF/CIP',
        RESET_PASSWORD_CONTACT: 'Selecionar contato',
        RESET_PASSWORD_NOVA_SENHA: 'Criar nova senha',
        RESET_PASSWORD_TOKEN: 'Inserir token',
        REVISAO_DADOS: 'Revisao_Dados',
        ACTIVATE_ACCOUNT_SENHA: 'Crie_senha',
        ACTIVATE_ACCOUNT_TOKEN: 'Token',
        ACTIVATE_ACCOUNT_SELECT_CONTACT: 'Selecione_Contato',
        ACTIVATE_ACCOUNT_CIP_CPF: 'Cpf',
        ACTIVATE_ACCOUNT_CIP_MODAL_INVALID: 'Cadastro_Divergente',
        ACTIVATE_ACCOUNT_FAP_MODAL_INVALID: 'FAP',
        ACTIVATE_ACCOUNT_CIP_MODAL_ACCOUNT_NAV: 'Conta_Nav',
        ACTIVATE_ACCOUNT_CIP_LOGIN_ACCOUNT_NAV: 'Conta_Dados',
        NEW_SEXO: 'New_Sexo',
        NEW_CONTATO: 'New_Contato',
        NEW_TOKEN: 'New_Token',
        NEW_ACTIVATE_MANUAL: 'New_Ativacao_Manual',
        NEW_ACTIVATE_CONCLUIDA: 'New_Ativação_Concluída',
        ACTIVATE_ACCOUNT_CIP_MANUAL: 'Conta_Ativacao_Manual',
        ACTIVATE_ACCOUNT_CIP_NEW_MANUAL: 'New_Ativacao_Manual',
        ACTIVATE_ACCOUNT_CIP_MDM_MANUAL: 'MDM_Ativacao_Manual',
        CADASTRO_DIVERGENTE: 'Cadastro_Divergente',
    },
    ONBOARDING_STEP: {
        event: 'vpageview',
    },
    ACTIVATE_ACCOUNT_SUCCESS: {
        HREF: 'vpageview/ativacao-cadastro-sucesso',
        EVENT: 'Ativacao_Cadastro_Concluido',
        USER: 'Completo',
    },
    CADASTRO_SUCESSO: {
        HREF: 'vpageview/cadastro-sucesso',
        EVENT: 'Cadastro_Concluido',
    },
    RESET_PASSWORD_SUCESSO: {
        EVENT: 'Reset_Senha_Concluido',
        HREF: 'vpageview/reset-sucesso',
        NAME: 'Reset de Senha',
    },
    AJUDA_LOGIN: {
        EVENT: 'vpageview',
        HREF: 'vpageview/login-ajuda',
    },
    PATH: {
        MDM: 'MDM',
        NEW: 'New',
        CIP: 'Cip_Orfa',
    },
    PATH_ACTIVATE_ACCOUNT: {
        RESET_PASSWORD: 'Reset',
        MDM: 'Mdm_Incompleto',
    },
    REGISTER_VALIDATION: {
        EMAIL: 'EMAIL',
        SMS: 'SMS',
    },
    LOGIN_TYPE: {
        CPF: 'CPF',
        CIP: 'CIP',
        FAP: 'FAP',
        RESET: 'Reset',
        SIGN_UP: 'Automático_pós_cadastro',
        LAB: 'LAB',
        NLAB: 'NLAB',
        AuthenticateHash: 'AuthenticateHash',
        AuthenticateUniqueToken: 'AuthenticateUniqueToken',
        AuthenticatePartner: 'AuthenticatePartner',
    },
    FUNNEL: {
        PATH: 'Cip Orfa',
        STEPS: {
            Mdm_Senha: 'Mdm_Senha',
            Mdm_Token: 'Mdm_Token',
            Mdm_Contato: 'Mdm_Contato',
        },
    },
    FUNNEL_RESET_PASSWORD: {
        name: 'Reset de Senha',
        current_step: 'Selecionar contato',
        origin: 'Reset de Senha',
    },
    FUNNEL_RESET_PASSWORD_TOKEN: {
        name: 'Reset de Senha',
        current_step: 'Token',
        origin: 'Reset de Senha',
    },
    USER: 'Completo',
    REASON: 'Cadastro_Divergente',
}
